import { z } from 'zod';
import { saleTypeEligibilitySchema } from './saleTypeEligibility.js';
import { subscriptionPredecessorCandidateSchema } from './subscriptionPredecessor.js';
export const creditBalancePoolSchema = z.object({
    poolUuid: z.string(),
    contractId: z.number().int().positive(),
    // The product the credits were sold as, e.g. "Craftsman Credits Silver".
    productName: z.string().nullable(),
    credits: z.number().int().min(0),
    // Net of MWST, as strings so no precision is lost in transit.
    value: z.string(),
    // Derived per credit pool.
    pricePerCredit: z.string(),
});
export const invoiceAddressFieldSchema = z.enum(['street', 'zip', 'city']);
export const partnerSaleContextSchema = z.object({
    remainingCredits: z.number().int().min(0),
    remainingMonetaryValue: z.string(),
    hasUnpaidInstallments: z.boolean(),
    // A partner still served by the old model cannot be sold a subscription (lead / time based).
    hasRunningOldPackage: z.boolean(),
    // The contract the subscription is recorded as continuing is the last one signed.
    lastSignedContractId: z.number().int().positive().nullable(),
    pools: z.array(creditBalancePoolSchema),
    eligibility: saleTypeEligibilitySchema,
    // The row the eligibility was derived from, offered as the prefilled predecessor.
    suggestedPredecessor: subscriptionPredecessorCandidateSchema.nullable(),
    predecessorCandidates: z.array(subscriptionPredecessorCandidateSchema),
    missingInvoiceAddressFields: z.array(invoiceAddressFieldSchema),
});
